import { State, Selector, StateContext, Action } from '@ngxs/store';
import { Whitelabel ,QRScanDetails} from '../models';
import { SetWhitelabel, SetOther, SetLandingPage,SetQRScannedDetails,ClearQRScannedDetails, SetAppVersion } from '../actions';
import { Injectable } from '@angular/core';

export class WhitelabelStateModel {
    whitelabel: Whitelabel;
    other: any;
    landingPage:any;
    appVersion:any;
    qrScanDetails:QRScanDetails;
}

@State<WhitelabelStateModel> ({
    name: 'whitelabel',
    defaults: {
        whitelabel: null,
        other: null,
        landingPage: null,
        qrScanDetails:null,
        appVersion: {
            version: "0.0.0",
            isForceUpdate:false,
            isRecommendUpdate:false
        }
    }
})

@Injectable()
export class WhitelabelState {

    @Selector()
    static getWhitelabel(state: WhitelabelStateModel){
        return state.whitelabel;
    }

    @Selector()
    static getOther(state: WhitelabelStateModel){
        return state.other;
    }
    @Selector()
    static getLandingPage(state: WhitelabelStateModel){
        return state.landingPage;
    }

    @Selector()
    static getAppVersion(state: WhitelabelStateModel){
        return state.appVersion;
    }
    
    @Selector()
    static getQRScanDetails(state: WhitelabelStateModel){
        return state.qrScanDetails;
    }

    @Action(SetWhitelabel)
    setWhitelabel({ patchState }: StateContext<WhitelabelStateModel>, { payload }: SetWhitelabel) {
        patchState({
            whitelabel: payload
        });
    }

    @Action(SetOther)
    setOther({ patchState }: StateContext<WhitelabelStateModel>, { payload }: SetOther) {
        patchState({
            other: payload
        });
    }
    @Action(SetLandingPage)
    setLandingPage({ patchState }: StateContext<WhitelabelStateModel>, { payload }: SetOther) {
        patchState({
            landingPage: payload
        });
    }
    @Action(SetAppVersion)
    setAppVersion({ patchState }: StateContext<WhitelabelStateModel>, { payload }: SetAppVersion) {
        patchState({
            appVersion: payload
        });
    }

    @Action(SetQRScannedDetails)
    setQRScanDetails({ patchState }: StateContext<WhitelabelStateModel>, { payload }: SetQRScannedDetails) {
        patchState({
            qrScanDetails: payload
        });
    }

    @Action(ClearQRScannedDetails)
    clearQRScannedDetails({ patchState }: StateContext<WhitelabelStateModel>) {
        patchState({
            qrScanDetails: null
        });
    }
    
    
}